import PropTypes from 'prop-types'
import { Button } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'
import { ReactComponent as Package } from '../../../assets/icons/package.svg'
import FixedBottomWrapper from '../../../ui/components/FixedBottomWrapper'

const CTA = ({ isFirstVisit, newAddedShippingCode, onVisitShippingSend }) => {
  const t = useTranslations()

  return (
    <>
      <FixedBottomWrapper fullWidth>
        <>
          <Button
            fullWidth
            startIcon={<Package />}
            onClick={onVisitShippingSend}
          >
            {isFirstVisit
              ? t('action:request-a-shipment-first')
              : t('action:request-a-shipment')}
          </Button>
        </>
      </FixedBottomWrapper>
    </>
  )
}

CTA.propTypes = {
  isFirstVisit: PropTypes.bool,
  onVisitShippingSend: PropTypes.func,
  newAddedShippingCode: PropTypes.string,
}

export default CTA
